/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ApiKeyResponse,
  CreateApiKeyBody,
  CreateSecretBody,
  DeleteSecretsBody,
  LegacyApiKeysResponse,
  PgsodiumConfigResponse,
  SecretResponse,
  UpdateApiKeyBody,
  UpdatePgsodiumConfigBody,
  V1CreateProjectApiKeyParams,
  V1DeleteProjectApiKeyParams,
  V1GetProjectApiKeyParams,
  V1GetProjectApiKeysParams,
  V1UpdateProjectApiKeyParams,
  V1UpdateProjectLegacyApiKeysParams
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * @summary Get project api keys
 */
export type v1GetProjectApiKeysResponse200 = {
  data: ApiKeyResponse[]
  status: 200
}

export type v1GetProjectApiKeysResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectApiKeysResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectApiKeysResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectApiKeysResponseSuccess = (v1GetProjectApiKeysResponse200) & {
  headers: Headers;
};
export type v1GetProjectApiKeysResponseError = (v1GetProjectApiKeysResponse401 | v1GetProjectApiKeysResponse403 | v1GetProjectApiKeysResponse429) & {
  headers: Headers;
};

export type v1GetProjectApiKeysResponse = (v1GetProjectApiKeysResponseSuccess | v1GetProjectApiKeysResponseError)

export const getV1GetProjectApiKeysUrl = (ref: string,
    params?: V1GetProjectApiKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/api-keys?${stringifiedParams}` : `/v1/projects/${ref}/api-keys`
}

export const v1GetProjectApiKeys = async (ref: string,
    params?: V1GetProjectApiKeysParams, options?: RequestInit): Promise<v1GetProjectApiKeysResponse> => {
  
  return customFetch<v1GetProjectApiKeysResponse>(getV1GetProjectApiKeysUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Creates a new API key for the project
 */
export type v1CreateProjectApiKeyResponse201 = {
  data: ApiKeyResponse
  status: 201
}

export type v1CreateProjectApiKeyResponse401 = {
  data: void
  status: 401
}

export type v1CreateProjectApiKeyResponse403 = {
  data: void
  status: 403
}

export type v1CreateProjectApiKeyResponse429 = {
  data: void
  status: 429
}

export type v1CreateProjectApiKeyResponseSuccess = (v1CreateProjectApiKeyResponse201) & {
  headers: Headers;
};
export type v1CreateProjectApiKeyResponseError = (v1CreateProjectApiKeyResponse401 | v1CreateProjectApiKeyResponse403 | v1CreateProjectApiKeyResponse429) & {
  headers: Headers;
};

export type v1CreateProjectApiKeyResponse = (v1CreateProjectApiKeyResponseSuccess | v1CreateProjectApiKeyResponseError)

export const getV1CreateProjectApiKeyUrl = (ref: string,
    params?: V1CreateProjectApiKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/api-keys?${stringifiedParams}` : `/v1/projects/${ref}/api-keys`
}

export const v1CreateProjectApiKey = async (ref: string,
    createApiKeyBody: CreateApiKeyBody,
    params?: V1CreateProjectApiKeyParams, options?: RequestInit): Promise<v1CreateProjectApiKeyResponse> => {
  
  return customFetch<v1CreateProjectApiKeyResponse>(getV1CreateProjectApiKeyUrl(ref,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createApiKeyBody,)
  }
);}
  

/**
 * @summary Check whether JWT based legacy (anon, service_role) API keys are enabled. This API endpoint will be removed in the future, check for HTTP 404 Not Found.
 */
export type v1GetProjectLegacyApiKeysResponse200 = {
  data: LegacyApiKeysResponse
  status: 200
}

export type v1GetProjectLegacyApiKeysResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectLegacyApiKeysResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectLegacyApiKeysResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectLegacyApiKeysResponseSuccess = (v1GetProjectLegacyApiKeysResponse200) & {
  headers: Headers;
};
export type v1GetProjectLegacyApiKeysResponseError = (v1GetProjectLegacyApiKeysResponse401 | v1GetProjectLegacyApiKeysResponse403 | v1GetProjectLegacyApiKeysResponse429) & {
  headers: Headers;
};

export type v1GetProjectLegacyApiKeysResponse = (v1GetProjectLegacyApiKeysResponseSuccess | v1GetProjectLegacyApiKeysResponseError)

export const getV1GetProjectLegacyApiKeysUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/api-keys/legacy`
}

export const v1GetProjectLegacyApiKeys = async (ref: string, options?: RequestInit): Promise<v1GetProjectLegacyApiKeysResponse> => {
  
  return customFetch<v1GetProjectLegacyApiKeysResponse>(getV1GetProjectLegacyApiKeysUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Disable or re-enable JWT based legacy (anon, service_role) API keys. This API endpoint will be removed in the future, check for HTTP 404 Not Found.
 */
export type v1UpdateProjectLegacyApiKeysResponse200 = {
  data: LegacyApiKeysResponse
  status: 200
}

export type v1UpdateProjectLegacyApiKeysResponse401 = {
  data: void
  status: 401
}

export type v1UpdateProjectLegacyApiKeysResponse403 = {
  data: void
  status: 403
}

export type v1UpdateProjectLegacyApiKeysResponse429 = {
  data: void
  status: 429
}

export type v1UpdateProjectLegacyApiKeysResponseSuccess = (v1UpdateProjectLegacyApiKeysResponse200) & {
  headers: Headers;
};
export type v1UpdateProjectLegacyApiKeysResponseError = (v1UpdateProjectLegacyApiKeysResponse401 | v1UpdateProjectLegacyApiKeysResponse403 | v1UpdateProjectLegacyApiKeysResponse429) & {
  headers: Headers;
};

export type v1UpdateProjectLegacyApiKeysResponse = (v1UpdateProjectLegacyApiKeysResponseSuccess | v1UpdateProjectLegacyApiKeysResponseError)

export const getV1UpdateProjectLegacyApiKeysUrl = (ref: string,
    params: V1UpdateProjectLegacyApiKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/api-keys/legacy?${stringifiedParams}` : `/v1/projects/${ref}/api-keys/legacy`
}

export const v1UpdateProjectLegacyApiKeys = async (ref: string,
    params: V1UpdateProjectLegacyApiKeysParams, options?: RequestInit): Promise<v1UpdateProjectLegacyApiKeysResponse> => {
  
  return customFetch<v1UpdateProjectLegacyApiKeysResponse>(getV1UpdateProjectLegacyApiKeysUrl(ref,params),
  {      
    ...options,
    method: 'PUT'
    
    
  }
);}
  

/**
 * @summary Updates an API key for the project
 */
export type v1UpdateProjectApiKeyResponse200 = {
  data: ApiKeyResponse
  status: 200
}

export type v1UpdateProjectApiKeyResponse401 = {
  data: void
  status: 401
}

export type v1UpdateProjectApiKeyResponse403 = {
  data: void
  status: 403
}

export type v1UpdateProjectApiKeyResponse429 = {
  data: void
  status: 429
}

export type v1UpdateProjectApiKeyResponseSuccess = (v1UpdateProjectApiKeyResponse200) & {
  headers: Headers;
};
export type v1UpdateProjectApiKeyResponseError = (v1UpdateProjectApiKeyResponse401 | v1UpdateProjectApiKeyResponse403 | v1UpdateProjectApiKeyResponse429) & {
  headers: Headers;
};

export type v1UpdateProjectApiKeyResponse = (v1UpdateProjectApiKeyResponseSuccess | v1UpdateProjectApiKeyResponseError)

export const getV1UpdateProjectApiKeyUrl = (ref: string,
    id: string,
    params?: V1UpdateProjectApiKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/api-keys/${id}?${stringifiedParams}` : `/v1/projects/${ref}/api-keys/${id}`
}

export const v1UpdateProjectApiKey = async (ref: string,
    id: string,
    updateApiKeyBody: UpdateApiKeyBody,
    params?: V1UpdateProjectApiKeyParams, options?: RequestInit): Promise<v1UpdateProjectApiKeyResponse> => {
  
  return customFetch<v1UpdateProjectApiKeyResponse>(getV1UpdateProjectApiKeyUrl(ref,id,params),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateApiKeyBody,)
  }
);}
  

/**
 * @summary Get API key
 */
export type v1GetProjectApiKeyResponse200 = {
  data: ApiKeyResponse
  status: 200
}

export type v1GetProjectApiKeyResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectApiKeyResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectApiKeyResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectApiKeyResponseSuccess = (v1GetProjectApiKeyResponse200) & {
  headers: Headers;
};
export type v1GetProjectApiKeyResponseError = (v1GetProjectApiKeyResponse401 | v1GetProjectApiKeyResponse403 | v1GetProjectApiKeyResponse429) & {
  headers: Headers;
};

export type v1GetProjectApiKeyResponse = (v1GetProjectApiKeyResponseSuccess | v1GetProjectApiKeyResponseError)

export const getV1GetProjectApiKeyUrl = (ref: string,
    id: string,
    params?: V1GetProjectApiKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/api-keys/${id}?${stringifiedParams}` : `/v1/projects/${ref}/api-keys/${id}`
}

export const v1GetProjectApiKey = async (ref: string,
    id: string,
    params?: V1GetProjectApiKeyParams, options?: RequestInit): Promise<v1GetProjectApiKeyResponse> => {
  
  return customFetch<v1GetProjectApiKeyResponse>(getV1GetProjectApiKeyUrl(ref,id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Deletes an API key for the project
 */
export type v1DeleteProjectApiKeyResponse200 = {
  data: ApiKeyResponse
  status: 200
}

export type v1DeleteProjectApiKeyResponse401 = {
  data: void
  status: 401
}

export type v1DeleteProjectApiKeyResponse403 = {
  data: void
  status: 403
}

export type v1DeleteProjectApiKeyResponse429 = {
  data: void
  status: 429
}

export type v1DeleteProjectApiKeyResponseSuccess = (v1DeleteProjectApiKeyResponse200) & {
  headers: Headers;
};
export type v1DeleteProjectApiKeyResponseError = (v1DeleteProjectApiKeyResponse401 | v1DeleteProjectApiKeyResponse403 | v1DeleteProjectApiKeyResponse429) & {
  headers: Headers;
};

export type v1DeleteProjectApiKeyResponse = (v1DeleteProjectApiKeyResponseSuccess | v1DeleteProjectApiKeyResponseError)

export const getV1DeleteProjectApiKeyUrl = (ref: string,
    id: string,
    params?: V1DeleteProjectApiKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/api-keys/${id}?${stringifiedParams}` : `/v1/projects/${ref}/api-keys/${id}`
}

export const v1DeleteProjectApiKey = async (ref: string,
    id: string,
    params?: V1DeleteProjectApiKeyParams, options?: RequestInit): Promise<v1DeleteProjectApiKeyResponse> => {
  
  return customFetch<v1DeleteProjectApiKeyResponse>(getV1DeleteProjectApiKeyUrl(ref,id,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary [Beta] Gets project's pgsodium config
 */
export type v1GetPgsodiumConfigResponse200 = {
  data: PgsodiumConfigResponse
  status: 200
}

export type v1GetPgsodiumConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetPgsodiumConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetPgsodiumConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetPgsodiumConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetPgsodiumConfigResponseSuccess = (v1GetPgsodiumConfigResponse200) & {
  headers: Headers;
};
export type v1GetPgsodiumConfigResponseError = (v1GetPgsodiumConfigResponse401 | v1GetPgsodiumConfigResponse403 | v1GetPgsodiumConfigResponse429 | v1GetPgsodiumConfigResponse500) & {
  headers: Headers;
};

export type v1GetPgsodiumConfigResponse = (v1GetPgsodiumConfigResponseSuccess | v1GetPgsodiumConfigResponseError)

export const getV1GetPgsodiumConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/pgsodium`
}

export const v1GetPgsodiumConfig = async (ref: string, options?: RequestInit): Promise<v1GetPgsodiumConfigResponse> => {
  
  return customFetch<v1GetPgsodiumConfigResponse>(getV1GetPgsodiumConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Updates project's pgsodium config. Updating the root_key can cause all data encrypted with the older key to become inaccessible.
 */
export type v1UpdatePgsodiumConfigResponse200 = {
  data: PgsodiumConfigResponse
  status: 200
}

export type v1UpdatePgsodiumConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdatePgsodiumConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdatePgsodiumConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdatePgsodiumConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdatePgsodiumConfigResponseSuccess = (v1UpdatePgsodiumConfigResponse200) & {
  headers: Headers;
};
export type v1UpdatePgsodiumConfigResponseError = (v1UpdatePgsodiumConfigResponse401 | v1UpdatePgsodiumConfigResponse403 | v1UpdatePgsodiumConfigResponse429 | v1UpdatePgsodiumConfigResponse500) & {
  headers: Headers;
};

export type v1UpdatePgsodiumConfigResponse = (v1UpdatePgsodiumConfigResponseSuccess | v1UpdatePgsodiumConfigResponseError)

export const getV1UpdatePgsodiumConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/pgsodium`
}

export const v1UpdatePgsodiumConfig = async (ref: string,
    updatePgsodiumConfigBody: UpdatePgsodiumConfigBody, options?: RequestInit): Promise<v1UpdatePgsodiumConfigResponse> => {
  
  return customFetch<v1UpdatePgsodiumConfigResponse>(getV1UpdatePgsodiumConfigUrl(ref),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePgsodiumConfigBody,)
  }
);}
  

/**
 * Returns all secrets you've previously added to the specified project.
 * @summary List all secrets
 */
export type v1ListAllSecretsResponse200 = {
  data: SecretResponse[]
  status: 200
}

export type v1ListAllSecretsResponse401 = {
  data: void
  status: 401
}

export type v1ListAllSecretsResponse403 = {
  data: void
  status: 403
}

export type v1ListAllSecretsResponse429 = {
  data: void
  status: 429
}

export type v1ListAllSecretsResponse500 = {
  data: void
  status: 500
}

export type v1ListAllSecretsResponseSuccess = (v1ListAllSecretsResponse200) & {
  headers: Headers;
};
export type v1ListAllSecretsResponseError = (v1ListAllSecretsResponse401 | v1ListAllSecretsResponse403 | v1ListAllSecretsResponse429 | v1ListAllSecretsResponse500) & {
  headers: Headers;
};

export type v1ListAllSecretsResponse = (v1ListAllSecretsResponseSuccess | v1ListAllSecretsResponseError)

export const getV1ListAllSecretsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/secrets`
}

export const v1ListAllSecrets = async (ref: string, options?: RequestInit): Promise<v1ListAllSecretsResponse> => {
  
  return customFetch<v1ListAllSecretsResponse>(getV1ListAllSecretsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Creates multiple secrets and adds them to the specified project.
 * @summary Bulk create secrets
 */
export type v1BulkCreateSecretsResponse201 = {
  data: void
  status: 201
}

export type v1BulkCreateSecretsResponse401 = {
  data: void
  status: 401
}

export type v1BulkCreateSecretsResponse403 = {
  data: void
  status: 403
}

export type v1BulkCreateSecretsResponse429 = {
  data: void
  status: 429
}

export type v1BulkCreateSecretsResponse500 = {
  data: void
  status: 500
}

export type v1BulkCreateSecretsResponseSuccess = (v1BulkCreateSecretsResponse201) & {
  headers: Headers;
};
export type v1BulkCreateSecretsResponseError = (v1BulkCreateSecretsResponse401 | v1BulkCreateSecretsResponse403 | v1BulkCreateSecretsResponse429 | v1BulkCreateSecretsResponse500) & {
  headers: Headers;
};

export type v1BulkCreateSecretsResponse = (v1BulkCreateSecretsResponseSuccess | v1BulkCreateSecretsResponseError)

export const getV1BulkCreateSecretsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/secrets`
}

export const v1BulkCreateSecrets = async (ref: string,
    createSecretBody: CreateSecretBody, options?: RequestInit): Promise<v1BulkCreateSecretsResponse> => {
  
  return customFetch<v1BulkCreateSecretsResponse>(getV1BulkCreateSecretsUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSecretBody,)
  }
);}
  

/**
 * Deletes all secrets with the given names from the specified project
 * @summary Bulk delete secrets
 */
export type v1BulkDeleteSecretsResponse200 = {
  data: void
  status: 200
}

export type v1BulkDeleteSecretsResponse401 = {
  data: void
  status: 401
}

export type v1BulkDeleteSecretsResponse403 = {
  data: void
  status: 403
}

export type v1BulkDeleteSecretsResponse429 = {
  data: void
  status: 429
}

export type v1BulkDeleteSecretsResponse500 = {
  data: void
  status: 500
}

export type v1BulkDeleteSecretsResponseSuccess = (v1BulkDeleteSecretsResponse200) & {
  headers: Headers;
};
export type v1BulkDeleteSecretsResponseError = (v1BulkDeleteSecretsResponse401 | v1BulkDeleteSecretsResponse403 | v1BulkDeleteSecretsResponse429 | v1BulkDeleteSecretsResponse500) & {
  headers: Headers;
};

export type v1BulkDeleteSecretsResponse = (v1BulkDeleteSecretsResponseSuccess | v1BulkDeleteSecretsResponseError)

export const getV1BulkDeleteSecretsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/secrets`
}

export const v1BulkDeleteSecrets = async (ref: string,
    deleteSecretsBody: DeleteSecretsBody, options?: RequestInit): Promise<v1BulkDeleteSecretsResponse> => {
  
  return customFetch<v1BulkDeleteSecretsResponse>(getV1BulkDeleteSecretsUrl(ref),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteSecretsBody,)
  }
);}
  

